function getBusStationsUrl(instance) {
    // TODO: Get values through model
    // const baseUrl = 'https://www.alsaviajes.com';
    const operativeUrl = instance.element.getAttribute('data-operative-url') || instance.config.operativeUrl;
    return `${operativeUrl}${getUrlParams(instance)}`;
}

function getUrlParams(instance) {
    const company = instance.element.getAttribute('data-company') || 'ALS';
    const busStationCode = instance.location[0].value;
    const { language } = instance;

    return `?company=${company}&origin=${busStationCode}&lang=${language}`;
}

function getBusStations(instance, callback) {
    const xhrCall = new XMLHttpRequest();
    xhrCall.open('GET', getBusStationsUrl(instance), true);
    xhrCall.send();
    xhrCall.onreadystatechange = function s() {
        if (xhrCall.readyState === XMLHttpRequest.DONE) {
            if (xhrCall.status === 200) {
                const busStations = JSON.parse(xhrCall.response);
                callback(busStations, instance);
            }
        }
    };
}

module.exports = {
    getBusStations
};
